import { config } from 'util/config';
import { httpClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';

export function addBySection({ sectionComponent } = {}) {
  resetCouncilFilter(sectionComponent);
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName } = {}) {
  // 在 Modal 显示前清除上一次的筛选结果，避免先闪出旧 Council 列表。
  resetCouncilFilter(sectionComponent);
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient.get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (!data.result) return globalFunction.handleResultError(data, pageComponent);
        sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key, formData: data.data });
        sectionComponent.customForm.current?.formRef.current?.setFieldsValue({ ...data.data, ShowSelectedItemsOnly: false });
        const optionLgaList = data.data.PlanningCodeOptionLgaList || [];
        const selectedRowKeys = optionLgaList.map(item => item.LgaId);
        const child = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
        child?.setState({ optionLgaList, selectedRowKeys, defaultSelectedRowKeys: selectedRowKeys, filteredData: child?.state.data || [] });
      })
      .catch((error) => globalFunction.handleError(error, pageComponent));
  }, config.setTimeoutMilliSecond);
}

function resetCouncilFilter(sectionComponent) {
  const customForm = sectionComponent.customForm.current;
  customForm?.formRef.current?.setFieldValue('ShowSelectedItemsOnly', false);
  const child = customForm?.additionalFormRef.current?.child.current;
  child?.setState({ optionLgaList: [], selectedRowKeys: [], defaultSelectedRowKeys: [], filteredData: child?.state.data || [] });
}

export function cancelCustomForm({ sectionComponent } = {}) {
  // 先关闭 Modal；等待关闭动画结束后才清表单，避免可见状态下出现列表展开闪动。
  sectionComponent.setState({ showModal: false, customFormSubmitting: false, isFormModified: false, componentType: null });
  setTimeout(() => {
    sectionComponent.customForm.current?.resetFields();
    resetCouncilFilter(sectionComponent);
  }, 300);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent } = {}) {
  const child = sectionComponent.customForm.current?.additionalFormRef.current?.child.current;
  child?.setState({ filteredData: parameter ? child.state.data.filter(item => child.state.selectedRowKeys.includes(item.key)) : child.state.data });
}
